import React, { useRef } from 'react';
import './style.scss';
import usePepe from '../../../../contexts/Pepe';
import SVGLandingNifty from '../../../../assets/login/first/nifty';
import SVGLandingHands from '../../../../assets/login/first/hands';
import Loader from '../../../general/loader';

interface Props {
  onComplete: () => any;
}

const LoginFirstStage = ({ onComplete }: Props) => {
  const { activate } = usePepe();
  const requiredChain = [0, 1, 0, 1, 2, 2, 2];
  const chain = useRef(requiredChain);

  const handleClick = (index: number) => {
    if (chain.current[0] !== index) {
      return activate();
    }
    chain.current = chain.current.slice(1);
    if (chain.current.length === 0) {
      onComplete();
    }
  };

  return (
    <div className='login-first-stage'>
      <div className='login-fs-wording'>
        <SVGLandingNifty
          className='login-fs-word'
          onClick={() => handleClick(0)}
        />
        <SVGLandingHands
          className='login-fs-word'
          onClick={() => handleClick(1)}
        />
      </div>
      <Loader
        size='Min(130px, 30vw)'
        color='primary'
        className='login-fs-loader'
        onClick={() => handleClick(2)}
      />
    </div>
  );
};

export default LoginFirstStage;
